module.exports = __webpack_public_path__ + "img/tu.bb7baa96.png";